import React, { useLayoutEffect, useEffect, useState, useRef, createRef, Component } from 'react';
import { Form, Templates as Templates$1, FieldWrapper } from '@truelime/react-forms';
import createDOMPurify from 'dompurify';
import axiosStatic from 'axios';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray$2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest();
}

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var frontEndFiltering = {
  FilterResults: function FilterResults(selectedFilters, allResults) {
    var removeEmptyArrays = function removeEmptyArrays(el) {
      return (el === null || el === void 0 ? void 0 : el.length) > 0;
    };
    var activeFilters = Object.values(selectedFilters).filter(removeEmptyArrays);
    if (!((activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length) > 0)) {
      return allResults;
    } else {
      var filteredResults = allResults.filter(function (result) {
        return activeFilters.every(function (activeFilterGroup) {
          return (activeFilterGroup === null || activeFilterGroup === void 0 ? void 0 : activeFilterGroup.some) && activeFilterGroup.some(function (filter) {
            return result.categories.includes(filter);
          });
        });
      });
      return filteredResults;
    }
  },
  getFormConfigWithCounters: function getFormConfigWithCounters(formConfig, selectedFilters, allResults, fieldLabelsWithCounters) {
    var flattenOptions = function flattenOptions(options) {
      var flatOptions = options.reduce(function (options, option) {
        var _option$options;
        options.push(option);
        if ((_option$options = option.options) === null || _option$options === void 0 ? void 0 : _option$options.length) {
          flattenOptions(option.options).forEach(function (option) {
            options.push(option);
          });
        }
        return options;
      }, []);
      return flatOptions;
    };
    var getPartWithCounters = function getPartWithCounters(part, selectedFilters, allResults) {
      var _part$options;
      // Check if the part has child parts
      if (part.part == "group" && Array.isArray(part.parts)) {
        var partsWithCounterValues = part.parts.map(function (childPart) {
          return getPartWithCounters(childPart, selectedFilters, allResults);
        });
        // Replace parts with counter values
        return _objectSpread$4(_objectSpread$4({}, part), {}, {
          parts: partsWithCounterValues
        });
      }
      if (part.hideCount || !(((_part$options = part.options) === null || _part$options === void 0 ? void 0 : _part$options.length) > 0)) {
        return part;
      }
      var removeEmptyArrays = function removeEmptyArrays(el) {
        return el.length > 0;
      };
      var activeFilters = Object.values(selectedFilters).filter(removeEmptyArrays);
      var flatOptions = flattenOptions(part.options);
      var counts = {};
      flatOptions.forEach(function (option) {
        var count = null;
        if (activeFilters.length == 0) {
          count = allResults.filter(function (item) {
            return item.categories.includes(option.value);
          }).length;
        } else {
          var activeFiltersWithoutOwnFiltergroup = activeFilters.filter(function (filter) {
            return filter.every(function (value) {
              return flatOptions.every(function (option) {
                return option.value != value;
              });
            });
          });
          count = allResults.filter(function (result) {
            return activeFiltersWithoutOwnFiltergroup.every(function (activeFilterGroup) {
              return (activeFilterGroup === null || activeFilterGroup === void 0 ? void 0 : activeFilterGroup.some) && activeFilterGroup.some(function (filter) {
                return result.categories.includes(filter);
              });
            });
          }).filter(function (item) {
            return item.categories.includes(option.value);
          }).length;
        }
        counts[option.value] = count;
      });
      var setCountsOnOption = function setCountsOnOption(option) {
        var count = counts[option.value];
        var disabled = count == 0 ? true : count > 0 ? false : false;
        var label = option.label || option.value || '';
        if (fieldLabelsWithCounters) {
          label = label.replace(/ \([0-9]+\)$/, '');
        }
        var options = option.options ? option.options.map(setCountsOnOption) : undefined;
        var optionWithCounts = _objectSpread$4(_objectSpread$4({}, option), {}, {
          label: label,
          disabled: disabled
        });
        if (fieldLabelsWithCounters) {
          optionWithCounts.label = "".concat(label, " (").concat(count, ")");
        } else {
          optionWithCounts.count = count;
        }
        if (options === null || options === void 0 ? void 0 : options.length) {
          optionWithCounts.options = options;
        }
        return optionWithCounts;
      };
      var options = part.options.map(setCountsOnOption);
      return _objectSpread$4(_objectSpread$4({}, part), {}, {
        options: options
      });
    };
    var parts = formConfig.steps[0].parts.map(function (part) {
      return getPartWithCounters(part, selectedFilters, allResults);
    });
    formConfig.steps[0].parts = parts;
    return _objectSpread$4({}, formConfig);
  },
  getFiltersFromValues: function getFiltersFromValues(values) {
    var filters = _objectSpread$4({}, values);
    for (var name in filters) {
      var value = filters[name];
      if (!Array.isArray(value)) {
        filters[name] = value ? [value] : []; // Save all filter values as arrays for easier further processing down the line
      }
    }
    // searchtext is always filtered in the backend
    if ('searchtext' in filters) {
      delete filters.searchtext;
    }
    return filters;
  },
  removeFilterValuesFromRequestOptions: function removeFilterValuesFromRequestOptions(requestOptions) {
    if (!(requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.data)) return;
    var namesToDelete = [];
    var _iterator = _createForOfIteratorHelper$1(requestOptions.data.entries()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 1),
          _name = _step$value[0];
        if (_name === 'searchtext') continue;
        namesToDelete.push(_name);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    for (var _i = 0, _namesToDelete = namesToDelete; _i < _namesToDelete.length; _i++) {
      var name = _namesToDelete[_i];
      requestOptions.data.delete(name);
    }
  }
};

var canUseDOM = !!(typeof window !== 'undefined' && window.document &&
// @ts-ignore: This condition will always return true since this function is always defined. Did you mean to call it instead?
window.document.createElement && window.navigator && window.navigator.userAgent);
var useIsomorphicLayoutEffect = canUseDOM ? useLayoutEffect : useEffect;
var purifyHTML = function purifyHTML(string) {
  if (canUseDOM) {
    var DOMPurify = createDOMPurify(window);
    DOMPurify.setConfig({
      ADD_ATTR: ['target']
    });
    string = DOMPurify.sanitize(string);
  }
  return {
    __html: string
  };
};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useDidMount = function useDidMount() {
  var mountRef = useRef(false);
  useIsomorphicLayoutEffect(function () {
    if (!canUseDOM) return;
    setTimeout(function () {
      return mountRef.current = true;
    }, 1);
  }, []);
  return function () {
    return mountRef.current;
  };
};
// TODO: #80013 Fix suggestion issues (https://dev.azure.com/truelime/Frontend/_workitems/edit/80013)
var SearchForm = function SearchForm(_ref) {
  var formRef = _ref.formRef,
    config = _ref.config,
    templates = _ref.templates,
    axios = _ref.axios,
    _ref$filterBackend = _ref.filterBackend,
    filterBackend = _ref$filterBackend === void 0 ? true : _ref$filterBackend,
    _ref$fieldLabelsWithC = _ref.fieldLabelsWithCounters,
    fieldLabelsWithCounters = _ref$fieldLabelsWithC === void 0 ? true : _ref$fieldLabelsWithC,
    onError = _ref.onError,
    onCancelled = _ref.onCancelled,
    onLoading = _ref.onLoading,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    onResults = _ref.onResults;
  var didMount = useDidMount();
  var _useState = useState(items),
    _useState2 = _slicedToArray(_useState, 2),
    allResults = _useState2[0],
    setAllResults = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedFilters = _useState4[0],
    setSelectedFilters = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    results = _useState6[0],
    setResults = _useState6[1];
  useIsomorphicLayoutEffect(function () {
    if (!didMount()) return;
    var filteredResults = filterBackend ? allResults : frontEndFiltering.FilterResults(selectedFilters, allResults);
    setResults(filteredResults);
  }, [selectedFilters, allResults]);
  var _useState7 = useState(config),
    _useState8 = _slicedToArray(_useState7, 2),
    configWithCounters = _useState8[0],
    setConfigWithCounters = _useState8[1];
  useIsomorphicLayoutEffect(function () {
    var _config$submit;
    if (filterBackend) return;
    if (((_config$submit = config.submit) === null || _config$submit === void 0 ? void 0 : _config$submit.action) && !didMount()) return; // If an action is filled in require a first request to retrieve all the results before we calculate the counts
    var newConfigWithCounters = frontEndFiltering.getFormConfigWithCounters(config, selectedFilters, allResults, fieldLabelsWithCounters);
    setConfigWithCounters(newConfigWithCounters);
  }, [config, selectedFilters, allResults]);
  useIsomorphicLayoutEffect(function () {
    if (!didMount()) return;
    if (onResults) onResults(results, selectedFilters);
  }, [results]);
  var _useState9 = useState(),
    _useState10 = _slicedToArray(_useState9, 2),
    values = _useState10[0],
    setValues = _useState10[1]; // Used to detect changes in values
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(newValues, requestOptions) {
      var _config$submit3;
      var _config$submit2, _filters, namesWithChangedValue, filters, searchtextChanged;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!filterBackend) {
                _context.next = 3;
                break;
              }
              if (onLoading) onLoading();
              return _context.abrupt("return");
            case 3:
              // Frontend filtering
              newValues = JSON.parse(JSON.stringify(newValues));
              // On pageload
              if (!(values === undefined)) {
                _context.next = 18;
                break;
              }
              setValues(newValues);
              _filters = frontEndFiltering.getFiltersFromValues(newValues);
              if (onLoading) onLoading();
              frontEndFiltering.removeFilterValuesFromRequestOptions(requestOptions);
              if (!((_config$submit2 = config.submit) === null || _config$submit2 === void 0 ? void 0 : _config$submit2.action)) {
                _context.next = 14;
                break;
              }
              setSelectedFilters(_filters);
              return _context.abrupt("return");
            case 14:
              _context.next = 16;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 1);
              });
            case 16:
              // Skip the first render pass so that all useEffects have been triggered
              setSelectedFilters(_filters);
              return _context.abrupt("return", false);
            case 18:
              namesWithChangedValue = Object.keys(_objectSpread$3(_objectSpread$3({}, values || {}), newValues)).filter(function (name) {
                return JSON.stringify(newValues[name]) !== JSON.stringify((values || {})[name]);
              });
              setValues(newValues);
              filters = frontEndFiltering.getFiltersFromValues(newValues);
              setSelectedFilters(filters);
              if (!((_config$submit3 = config.submit) === null || _config$submit3 === void 0 ? void 0 : _config$submit3.action)) {
                _context.next = 28;
                break;
              }
              searchtextChanged = namesWithChangedValue.some(function (name) {
                return name === 'searchtext';
              });
              if (!searchtextChanged) {
                _context.next = 28;
                break;
              }
              if (onLoading) onLoading();
              frontEndFiltering.removeFilterValuesFromRequestOptions(requestOptions);
              return _context.abrupt("return");
            case 28:
              return _context.abrupt("return", false);
            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function handleSubmit(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleSubmitted = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(response, values, requestOptions) {
      var results;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              results = response.data.resultItems || [];
              setAllResults(results);
            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function handleSubmitted(_x3, _x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleError = function handleError(e) {
    if (onError) onError(e);
  };
  // const handleCancelled = (e) => {
  //   if (onCancelled) onCancelled(e);
  // }
  return /*#__PURE__*/React.createElement(Form, {
    ref: formRef,
    config: configWithCounters,
    axios: axios,
    templates: templates,
    onSubmit: handleSubmit,
    onSubmitted: handleSubmitted,
    onError: handleError,
    onCancelled: onCancelled
  });
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var SuggestionTemplate = (function (_ref) {
  var suggestion = _ref.suggestion,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("button", {
    className: "searchtext__suggestion-button",
    onClick: onClick
  }, suggestion);
});

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var CancelToken = axiosStatic.CancelToken;
var SearchText = /*#__PURE__*/function (_FieldWrapper) {
  _inherits(SearchText, _FieldWrapper);
  var _super = _createSuper$2(SearchText);
  function SearchText(props) {
    var _this;
    _classCallCheck(this, SearchText);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "inputRef", void 0);
    _defineProperty(_assertThisInitialized(_this), "cancelTokenSource", void 0);
    _defineProperty(_assertThisInitialized(_this), "scheduledGetSuggestions", void 0);
    _defineProperty(_assertThisInitialized(_this), "scheduledBlurEvent", void 0);
    _defineProperty(_assertThisInitialized(_this), "scheduledOnChange", void 0);
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var _e$target$value;
      e.persist();
      var onChange = _this.props.formikField.onChange;
      var _this$props$config = _this.props.config,
        _this$props$config$de = _this$props$config.debounce,
        debounce = _this$props$config$de === void 0 ? 500 : _this$props$config$de,
        _this$props$config$su = _this$props$config.suggestionsDebouce,
        suggestionsDebouce = _this$props$config$su === void 0 ? 500 : _this$props$config$su,
        _this$props$config$su2 = _this$props$config.suggestionsMinLength,
        suggestionsMinLength = _this$props$config$su2 === void 0 ? 1 : _this$props$config$su2;
      clearTimeout(_this.scheduledOnChange);
      _this.scheduledOnChange = setTimeout(function () {
        onChange(e);
      }, debounce);
      _this.setState(_objectSpread$2(_objectSpread$2({}, _this.state), {}, {
        suggestions: [],
        value: e.target.value
      }));
      if (((_e$target$value = e.target.value) === null || _e$target$value === void 0 ? void 0 : _e$target$value.length) < suggestionsMinLength) return;
      if (_this.cancelTokenSource || _this.scheduledGetSuggestions) {
        // Delay next call to prevent server overload
        if (_this.scheduledGetSuggestions) {
          clearTimeout(_this.scheduledGetSuggestions);
          _this.scheduledGetSuggestions = undefined;
        }
        if (_this.cancelTokenSource) {
          _this.cancelTokenSource.cancel('Pending getSuggestions cancelled by a new getSuggestions');
          _this.cancelTokenSource = undefined;
        }
        _this.scheduledGetSuggestions = setTimeout(function () {
          _this.scheduledGetSuggestions = undefined;
          _this.getSuggestions(e.target.value);
        }, suggestionsDebouce);
      } else {
        _this.getSuggestions(e.target.value);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      e.persist(); // Keep available after setTimeout
      var _this$props$config$su3 = _this.props.config.suggestionsDebouce,
        suggestionsDebouce = _this$props$config$su3 === void 0 ? 500 : _this$props$config$su3;
      _this.scheduledBlurEvent = setTimeout(function () {
        if (_this.cancelTokenSource) {
          _this.cancelTokenSource.cancel('Pending getSuggestions cancelled by a blur event');
          delete _this.cancelTokenSource;
        }
        _this.scheduledBlurEvent = undefined;
        var isSuggestionButton = document.activeElement.classList.value === 'field__searchtext-suggestion-button';
        if (isSuggestionButton) return;
        _this.onBlur(e);
        _this.setState(_objectSpread$2(_objectSpread$2({}, _this.state), {}, {
          suggestions: []
        }));
      }, suggestionsDebouce);
    });
    _defineProperty(_assertThisInitialized(_this), "getSuggestions", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
        var _this$props$config2, suggestionsUrl, _this$props$config2$s, suggestionsMethod, source, _this$props$axios, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props$config2 = _this.props.config, suggestionsUrl = _this$props$config2.suggestionsUrl, _this$props$config2$s = _this$props$config2.suggestionsMethod, suggestionsMethod = _this$props$config2$s === void 0 ? 'POST' : _this$props$config2$s;
                if (suggestionsUrl) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                if (_this.cancelTokenSource) {
                  _this.cancelTokenSource.cancel('Pending getSuggestions cancelled by a new getSuggestions');
                }
                source = CancelToken.source();
                _this.cancelTokenSource = source;
                _context.prev = 6;
                _context.next = 9;
                return _this.props.axios((_this$props$axios = {
                  url: suggestionsUrl,
                  method: suggestionsMethod
                }, _defineProperty(_this$props$axios, suggestionsMethod === 'GET' ? 'params' : 'data', {
                  searchtext: value
                }), _defineProperty(_this$props$axios, "cancelToken", source.token), _this$props$axios));
              case 9:
                result = _context.sent;
                _this.setState(_objectSpread$2(_objectSpread$2({}, _this.state), {}, {
                  suggestions: result.data
                }));
                _context.next = 16;
                break;
              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](6);
                console.warn(_context.t0);
              case 16:
                _context.prev = 16;
                if (_this.cancelTokenSource === source) delete _this.cancelTokenSource;
                return _context.finish(16);
              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 13, 16, 19]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "onFocus", function () {
      _this.setState(_objectSpread$2(_objectSpread$2({}, _this.state), {}, {
        focused: true
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "onBlur", function (e) {
      _this.setState(_objectSpread$2(_objectSpread$2({}, _this.state), {}, {
        focused: false
      }));
      if (e) _this.props.formikField.onBlur(e);
    });
    _this.state = {
      suggestions: [],
      value: props.formikField.value
    };
    _this.inputRef = /*#__PURE__*/createRef();
    return _this;
  }
  _createClass(SearchText, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      if (props.formikField.value === this.state.value) return;
      if (this.props.formikField.value === props.formikField.value) return;
      this.setState(_objectSpread$2(_objectSpread$2({}, this.state), {}, {
        value: props.formikField.value
      }));
    }
  }, {
    key: "selectSuggestion",
    value: function selectSuggestion(name, value) {
      if (this.scheduledBlurEvent) {
        clearTimeout(this.scheduledBlurEvent);
        this.scheduledBlurEvent = undefined;
      }
      this.props.formikForm.setFieldValue(name, value);
      this.setState(_objectSpread$2(_objectSpread$2({}, this.state), {}, {
        suggestions: []
      }));
    }
  }, {
    key: "renderField",
    value: function renderField() {
      var _this$props$templates,
        _this$props$templates2,
        _this$props$templates3,
        _this$props$templates4,
        _this$props$templates5,
        _this2 = this;
      var _this$props = this.props,
        formikForm = _this$props.formikForm,
        formikField = _this$props.formikField,
        isRequired = _this$props.isRequired,
        _this$props$config3 = _this$props.config,
        icon = _this$props$config3.icon,
        label = _this$props$config3.label,
        labelInInput = _this$props$config3.labelInInput,
        labelHidden = _this$props$config3.labelHidden,
        name = _this$props$config3.name,
        placeholder = _this$props$config3.placeholder,
        readOnly = _this$props$config3.readOnly,
        disabled = _this$props$config3.disabled,
        autofocus = _this$props$config3.autofocus,
        buttonIcon = _this$props$config3.buttonIcon,
        _this$props$config3$b = _this$props$config3.buttonTitle,
        buttonTitle = _this$props$config3$b === void 0 ? 'Zoeken' : _this$props$config3$b;
        _this$props$config3.suggestionsUrl;
        var _this$props$config3$s = _this$props$config3.submitOnEnter,
        submitOnEnter = _this$props$config3$s === void 0 ? false : _this$props$config3$s;
      var _this$state = this.state,
        suggestions = _this$state.suggestions,
        value = _this$state.value;
      var Icon = ((_this$props$templates = this.props.templates) === null || _this$props$templates === void 0 ? void 0 : (_this$props$templates2 = _this$props$templates.Common) === null || _this$props$templates2 === void 0 ? void 0 : _this$props$templates2.Icon) || Templates$1.Common.Icon;
      var Suggestion = ((_this$props$templates3 = this.props.templates) === null || _this$props$templates3 === void 0 ? void 0 : (_this$props$templates4 = _this$props$templates3.Common) === null || _this$props$templates4 === void 0 ? void 0 : (_this$props$templates5 = _this$props$templates4.SearchText) === null || _this$props$templates5 === void 0 ? void 0 : _this$props$templates5.Suggestion) || SuggestionTemplate;
      var optionalAttributes = {};
      if (submitOnEnter) {
        optionalAttributes.onKeyPress = function (event) {
          if (event.key !== 'Enter') return;
          formikForm.submitForm();
        };
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "searchtext"
      }, /*#__PURE__*/React.createElement("div", {
        className: "field__input-container"
      }, icon && /*#__PURE__*/React.createElement(Icon, {
        className: "field__icon",
        iconName: icon,
        title: label
      }), (icon || labelInInput) && /*#__PURE__*/React.createElement("label", {
        className: "field__input-label ".concat(labelHidden ? 'sr-only' : ''),
        htmlFor: name,
        dangerouslySetInnerHTML: purifyHTML(label)
      }), /*#__PURE__*/React.createElement("input", _objectSpread$2(_objectSpread$2({
        ref: this.inputRef,
        id: name,
        className: "field__input field__searchtext-input",
        type: "text",
        placeholder: placeholder,
        readOnly: !!readOnly,
        disabled: !!disabled,
        "aria-required": !!isRequired
      }, formikField), {}, {
        value: value !== null && value !== void 0 ? value : '',
        onFocus: this.onFocus,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        "data-autofocus": autofocus,
        autoComplete: "off"
      }, optionalAttributes)), buttonIcon && /*#__PURE__*/React.createElement("button", {
        className: "searchtext__btn",
        type: "button",
        onClick: function onClick() {
          formikForm.submitForm();
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        className: "btn__icon",
        iconName: buttonIcon,
        title: buttonTitle
      }))), (suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) > 0 && /*#__PURE__*/React.createElement("ul", {
        className: "searchtext__suggestions"
      }, suggestions.map(function (suggestion) {
        return /*#__PURE__*/React.createElement("li", {
          key: JSON.stringify(suggestion),
          className: "searchtext__suggestion"
        }, /*#__PURE__*/React.createElement(Suggestion, {
          suggestion: suggestion,
          onClick: function onClick() {
            return _this2.selectSuggestion(name, suggestion);
          }
        }));
      })));
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      return null;
    }
  }]);
  return SearchText;
}(FieldWrapper);

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Templates = _objectSpread$1(_objectSpread$1({}, Templates$1), {}, {
  Field: _objectSpread$1(_objectSpread$1({}, Templates$1.Field), {}, {
    Searchtext: SearchText
  })
});

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$2(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread();
}

var propTypesExports = {};
var propTypes = {
  get exports(){ return propTypesExports; },
  set exports(v){ propTypesExports = v; },
};

var reactIsExports = {};
var reactIs = {
  get exports(){ return reactIsExports; },
  set exports(v){ reactIsExports = v; },
};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIsExports;
	hasRequiredReactIs = 1;
	(function (module) {

		if (process.env.NODE_ENV === 'production') {
		  module.exports = requireReactIs_production_min();
		} else {
		  module.exports = requireReactIs_development();
		}
} (reactIs));
	return reactIsExports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var checkPropTypes = requireCheckPropTypes();

	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }

	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var SelectedFilterOption = /*#__PURE__*/function (_Component) {
  _inherits(SelectedFilterOption, _Component);
  var _super = _createSuper$1(SelectedFilterOption);
  function SelectedFilterOption() {
    _classCallCheck(this, SelectedFilterOption);
    return _super.apply(this, arguments);
  }
  _createClass(SelectedFilterOption, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        config = _this$props.config;
      return /*#__PURE__*/React.createElement("button", {
        className: "selectedfilters__field",
        onClick: this.props.onClick
      }, (config === null || config === void 0 ? void 0 : config.label) || value);
    }
  }]);
  return SelectedFilterOption;
}(Component);
_defineProperty(SelectedFilterOption, "propTypes", {
  config: propTypesExports.any,
  value: propTypesExports.any.isRequired,
  onClick: propTypesExports.any.isRequired
});

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var SelectedFiltersGroup = /*#__PURE__*/function (_Component) {
  _inherits(SelectedFiltersGroup, _Component);
  var _super = _createSuper(SelectedFiltersGroup);
  function SelectedFiltersGroup() {
    _classCallCheck(this, SelectedFiltersGroup);
    return _super.apply(this, arguments);
  }
  _createClass(SelectedFiltersGroup, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        config = _this$props.config,
        values = _this$props.values;
      return Array.isArray(values) && (values === null || values === void 0 ? void 0 : values.map(function (value, i) {
        var _config$options;
        var optionConfig = config === null || config === void 0 ? void 0 : (_config$options = config.options) === null || _config$options === void 0 ? void 0 : _config$options.find(function (option) {
          return (option === null || option === void 0 ? void 0 : option.value) === value;
        });
        return /*#__PURE__*/React.createElement(SelectedFilterOption, {
          key: i,
          config: optionConfig,
          value: value,
          onClick: function onClick() {
            return _this.deleteFilter(value);
          }
        });
      }));
    }
  }, {
    key: "deleteFilter",
    value: function deleteFilter(value) {
      var values = _toConsumableArray(this.props.values).filter(function (groupValue) {
        return groupValue !== value;
      });
      this.props.setFilterGroupValues(values);
    }
  }]);
  return SelectedFiltersGroup;
}(Component);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SelectedFilters = function SelectedFilters(props) {
  var searchFormRef = props.searchFormRef,
    searchFormConfig = props.searchFormConfig,
    selectedFilters = props.selectedFilters,
    clearAllFiltersText = props.clearAllFiltersText;
  var clearAllFilters = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var formik, namesToClear, values, _iterator, _step, name;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              formik = searchFormRef.current.formikRef.current;
              namesToClear = [];
              Object.keys(formik.values).forEach(function (fieldName) {
                return namesToClear.push(fieldName);
              });
              if (namesToClear.length) {
                values = _objectSpread({}, formik.values);
                _iterator = _createForOfIteratorHelper(namesToClear);
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    name = _step.value;
                    delete values[name];
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                searchFormRef.current.formikRef.current.setValues(values);
              }
              _context.next = 6;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 1);
              });
            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function clearAllFilters() {
      return _ref.apply(this, arguments);
    };
  }();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    fieldConfigs = _useState2[0],
    setFieldConfigs = _useState2[1];
  useIsomorphicLayoutEffect(function () {
    if (!searchFormConfig) return;
    var newFieldConfigs = [];
    searchFormConfig.steps.forEach(function (step) {
      newFieldConfigs.push.apply(newFieldConfigs, _toConsumableArray(Form.flattenFields(step)));
    });
    setFieldConfigs(newFieldConfigs);
  }, [searchFormConfig]);
  return /*#__PURE__*/React.createElement("div", {
    className: "selectedfilters"
  }, selectedFilters && /*#__PURE__*/React.createElement(React.Fragment, null, Object.keys(selectedFilters).map(function (name, i) {
    var fieldConfig = fieldConfigs.find(function (fieldConfig) {
      return (fieldConfig === null || fieldConfig === void 0 ? void 0 : fieldConfig.name) === name;
    });
    return /*#__PURE__*/React.createElement(SelectedFiltersGroup, {
      key: i,
      config: fieldConfig,
      values: selectedFilters[name],
      setFilterGroupValues: function setFilterGroupValues(values) {
        searchFormRef.current.formikRef.current.setFieldValue(name, values);
      }
    });
  }), Object.keys(selectedFilters).some(function (name) {
    return Array.isArray(selectedFilters[name]) && selectedFilters[name].length > 0;
  }) && /*#__PURE__*/React.createElement("button", {
    className: "selectedfilters__button",
    onClick: clearAllFilters
  }, clearAllFiltersText)));
};

export { SearchForm, Templates as SearchFormTemplates, SelectedFilters };
